import Cookies from 'js-cookie';

export const setClientCookie = (
  name: string,
  value: string,
  options?: {path?: string; secure?: boolean}
) => {
  Cookies.set(name, value, {
    httpOnly: false,
    path: options?.path || '/',
    secure: options?.secure || process.env.NODE_ENV === 'production',
  });
};

export const getClientCookie = (name: string): string | undefined => {
  return Cookies.get(name);
};
